<template>
	<Modal 
	:title="'USUÁRIOS'"
	:loading="loading"
	@close="close">

		<div v-if="user == false">
			<button class="button-edit new-user" @click="user = 'new'">
				<i class="fa fa-plus"></i> Novo usuário
			</button>

			<Table 
			:loading="loading"
			:headers="headers" 
			:modifiers="modifiers" 
			:ordering="[]" 
			:list="list" 
			:page="0"
			:per_page="0" 
			:total="total" 
			v-slot="{item}">

				<button class="button-edit" @click="user = item" title="Editar">
					<i class="fa fa-fw fa-edit"></i>
				</button>

				<button v-if="item.status == '1'" class="button-edit" @click="disable(item.id)" title="Desativar">
					<i class="far fa-fw fa-check-square"></i>
				</button>
				<button v-if="item.status == '0'" class="button-edit" @click="enable(item.id)" title="Ativar">
					<i class="far fa-fw fa-square"></i>
				</button>

				<button class="button-remove" @click="remove(item.id)" title="Excluir">
					<i class="fa fa-fw fa-trash"></i>
				</button>

			</Table>
		</div>

		<AdminCompanyUserForm v-if="user != false" :current="user" :company="current.id" @back="user = false" @load="load" />

	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import Table from "@/components/Table";
import AdminCompanyUserForm from './AdminCompanyUserForm';

export default {
	name: "AdminCompanyUsers",

	props: [ "current" ],

	components: { Modal, Table, AdminCompanyUserForm },

	data: function() {
		return {
			loading: true,
			list: [],
			total: 0,
			headers: {
				name: "Nome",
				is_admin: "Tipo",
			},
			modifiers: {
				is_admin: function(is_admin) {
					if (is_admin) return "Administrador";
					return "Comum";
				}
			},

			user: false,
		};
	},


	mounted: function() {
		this.load();
	},


	activated: function() {
		this.load();
	},


	methods: {
		load: async function() {
			this.list = [];

			this.loading = true;
			let res = await Api.post_admin("user/list", { fk_company: this.current.id });
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				this.close();
			}

			this.total = res.total;
			this.list = res.data;
		},


		enable: async function(id) {
			this.loading = true;
			let res = await Api.post_admin("user/enable", { id: id, fk_company: this.current.id });

			if (res.error) {
				this.$notification.error(res.data);
				this.close();
			}

			this.$notification.success("Habilitado com sucesso.");
			this.load();
		},


		disable: async function(id) {
			this.loading = true;
			let res = await Api.post_admin("user/disable", { id: id, fk_company: this.current.id });

			if (res.error) {
				this.$notification.error(res.data);
				this.close();
			}

			this.$notification.success("Desabilitado com sucesso.");
			this.load();
		},


		remove: async function(id) {
			const confirm = await this.$alert.confirm("Tem certeza que deseja remover o usuário?");
			if (!confirm) return;

			this.loading = true;
			let res = await Api.post_admin("user/delete", { id: id });

			if (res.error) {
				this.$notification.error(res.data);
				this.close();
			}

			this.$notification.success("Removido com sucesso.");
			this.load();
		},


		close: function() {
			this.$parent.show_users = false;
		}
	}
}

</script>

<style scoped>

.new-user {
	float: right;
	margin-bottom: 15px;
}


</style>